import styled from 'styled-components';
import { FileSelector } from 'react-rainbow-components';
import Button from 'components/Button';

export const StyledFileSelector = styled(FileSelector)`
    height: 200px;
`;

export const StyledButton = styled(Button)`
    width: 100%;
    margin-bottom: 1.5rem;

    &[disabled] {
        box-shadow: none; !important;
    }
`;

export const ButtonLabel = styled.span`
    width: 100%;
    padding-left: 1.4rem;
`;

export const TopContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
`;
